<template>
  <div id="main-container">
    <ToolBar />
    <AppBody>
      <template #sidebar><CalendarSidebar /></template>
      <template #default>
        <DayView v-if="appointmentStore.calendarView === 'Day'" />
        <WeekView v-if="appointmentStore.calendarView === 'Week'" />
        <PodView v-if="appointmentStore.calendarView === 'Pod'" />
      </template>
    </AppBody>
    <ClientListModal />
  </div>
</template>

<script setup>
import AppBody from "./AppBody.vue";
import ToolBar from "./ToolBar.vue";
import CalendarSidebar from "./calendarview/sidebar.vue";
import DayView from "./calendarview/calendar.vue";
import WeekView from "./calendarview/Week.vue";
import PodView from "./calendarview/Pod.vue";
import ClientListModal from "./client/ClientListModal.vue";
import { useEvents, useStylists } from "../composables/events";
import { provide } from "vue";
import { useEventStore } from "./../stores/EventStore";
import { useAppointmentStore } from "../stores/appointmentsStore";
import { useMarkedStylists } from "../composables/appointments";

const eventStore = useEventStore();
const stylists = useStylists();
const appointmentStore = useAppointmentStore();

const { events, selectedDate } = useEvents();
const marked_stylists = useMarkedStylists();

provide("events", events);
provide("stylists", stylists);
provide("selectedDate", selectedDate);
eventStore.$subscribe((mutation, state) => {
  // getEvents getter now filters out temp event properties
  const validEvents = eventStore.getEvents;

  appointmentStore.jobCount = validEvents.reduce((acc, el) => {
    if (el && el.services && Array.isArray(el.services)) {
      el.services.forEach((service) => {
        if (typeof service !== "undefined") {
          acc[service.id] = service.id in acc ? acc[service.id] + 1 : 1;
        }
      });
    }
    return acc;
  }, {});
});
function searchEvent(id) {
  console.log(id);
}
</script>

<style>
#sidebar {
  width: 18%;
  background-color: white;
  padding: 1rem .5rem;
}

#main-body {
  display: flex;
  background-color: #f5f5f5;
  position: relative;
}
#calendar-boxed {
  width: 100%;
  margin: 0px 8px;
  margin-top: 8px;
  max-height: 1000px;
  overflow: scroll;
}

#calendar-box {
  padding-top: 10px;
  display: flex;
  background-color: white;
}
</style>
